// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import ReactMarkdown from "react-markdown";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Star, StarBorder, StarHalf } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";

import { ColorSchema } from "../../global/types/scss";
import { buttonStyles } from "../../global/components/StyledButtons";
import TipsWarning from "./TipsWarning";

function getSteps(): Array<string> {
  return ["Upload First Photo", "Upload More Photos"];
}

function getStepOptional(step: number): string {
  switch (step) {
    case 0:
      return "Upload your first photo for FaceTag.";
    case 1:
      return "Minimum 2 photos would be great.";
    case 2:
      return "Setup completed - you could still upload more photos.";
    default:
      return "";
  }
}

type UserStepperStatesType = {
  activeStep: number
};

type UserStepperPropsType = {
  classes: { [key: string]: string },
  db: { enrolments: Array<{ enrolment_uid: string, face_url: string }>, conference: { [key: string]: Object } },
  setComplete: Function
};

class UserStepper extends Component<UserStepperPropsType, UserStepperStatesType> {
  warning: React$Element<*>;
  constructor(props: UserStepperPropsType) {
    super(props);
    this.state = {
      activeStep: 0
    };
  }

  componentDidMount() {
    this.setState({ activeStep: Math.min(this.props.db.enrolments.length, 2) });
  }

  componentWillReceiveProps(nextProps: UserStepperPropsType) {
    const count = Math.min(nextProps.db.enrolments.length, 2);
    if (this.state.activeStep !== count) {
      this.setState({ activeStep: count });
    }
  }

  handleClick = (): * => {
    const tips = this.props.db.conference.photo_upload_tips;
    if(tips) {
      this.warning.handleClickOpen();
    }
    else {
      this.props.setComplete();
    }
  }

  render(): React$Element<*> | null {
    const steps = getSteps();
    const { activeStep } = this.state;
    const classes = this.props.classes;
    let starIcon;
    if (activeStep === 0) {
      starIcon = <StarBorder className={classes.shineIcon + " big-icon right-margin-10"} style={{ verticalAlign: "middle" }} />;
    }
    else if (activeStep === 1) {
      starIcon = <StarHalf className={classes.shineIcon + " big-icon right-margin-10"} style={{ verticalAlign: "middle" }} />;
    }
    else {
      starIcon = <Star className={classes.shineIcon + " big-icon right-margin-10"} style={{ verticalAlign: "middle" }} />;
    }
    const tips = this.props.db.conference.photo_upload_tips;

    return (
      <div>
        <Stepper activeStep={activeStep} style={{ color: ColorSchema("secondary") }}>
          {steps.map((label: string, index: number) => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div>
          {starIcon}
          <Typography variant="body1" style={{ display: "inline-table", color: ColorSchema("primary") }}>
            {getStepOptional(activeStep)}
          </Typography>
          {tips && activeStep === 0 &&
          <Typography variant="body1" style={{ display: "inline-table", marginLeft: "58px", color: ColorSchema("primary") }}>
            Tips:
            <ReactMarkdown source={tips} />
          </Typography>
          }
          {activeStep === steps.length &&
            <Button variant="raised" color="primary" className={classes.shineBtn + " left-margin-5"} onClick={this.handleClick}>
              Finish
            </Button>
          }
        </div>
        <TipsWarning onRef={(ref: ReactElement): * => (this.warning = ref)} setComplete={this.props.setComplete} tips={tips} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { db: state.forensic.db };
}

export default connect(mapStateToProps, null)(withStyles(buttonStyles)(UserStepper));


// WEBPACK FOOTER //
// ./src/conference/component/Stepper.js